import { fetchSmsPhoneNumbers } from '@/features/domain/account'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { useEffect, useState } from 'react'

export function useFetchPhoneNumbers() {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const [phoneNumbers, setPhoneNumbers] = useState<string[] | null>(null)

  useEffect(() => {
    const fetchPhoneNumbers = async () => {
      try {
        const thunkResult = await dispatch(fetchSmsPhoneNumbers())

        if (fetchSmsPhoneNumbers.rejected.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        setPhoneNumbers(thunkResult.payload)
      } catch (e) {
        toast.error((e as Error).message)
      }
    }

    fetchPhoneNumbers()
  }, [dispatch, toast])

  return phoneNumbers
}
